var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 136,
    viewBox: "0 0 134 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 136,
    rx: 67,
    fill: "url(#paint0_linear_3108_17677)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.75 47.4317C86.3725 46.3042 74.9267 45.7234 63.515 45.7234C56.75 45.7234 49.985 46.0651 43.22 46.7484L36.25 47.4317",
    stroke: "#BA4831",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0415 43.9809L55.7932 39.505C56.3398 36.2592 56.7498 33.8334 62.524 33.8334H71.4757C77.2498 33.8334 77.694 36.3959 78.2065 39.5392L78.9582 43.9809",
    stroke: "#BA4831",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.404 58.2284L88.1832 92.6342C87.8074 97.9984 87.4999 102.167 77.9674 102.167H56.0324C46.4999 102.167 46.1924 97.9984 45.8165 92.6342L43.5957 58.2284",
    stroke: "#BA4831",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2939 83.375H72.6714",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4585 69.7084H75.5418",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3108_17677",
    x1: 67,
    y1: 0,
    x2: 67,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.81d1f13aafb30393f8712efcd2e7e38e.svg";
export { ForwardRef as ReactComponent };